var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/token';
import http from 'app/services/http';
const initialState = {
    items: [],
    searchValue: '',
    selectedItem: null,
    transportGroups: [],
    transportGroupsTokenId: null,
};
const mergeTokenItem = (item, data) => {
    var _a, _b;
    return (Object.assign(Object.assign(Object.assign({}, item), data), { can_guard: (_a = data.can_guard) !== null && _a !== void 0 ? _a : item.can_guard, can_alarm_off: (_b = data.can_alarm_off) !== null && _b !== void 0 ? _b : item.can_alarm_off }));
};
export const tokenReducer = (state = initialState, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    switch (action.type) {
        case 'TOKEN_SET_ITEMS': {
            const { items } = (_a = action.payload) !== null && _a !== void 0 ? _a : {};
            return Object.assign(Object.assign({}, state), { items: items !== null && items !== void 0 ? items : state.items });
        }
        case 'TOKEN_SET_SELECTED_ITEM': {
            const { data } = (_b = action.payload) !== null && _b !== void 0 ? _b : {};
            const selectedItem = data !== null && data !== void 0 ? data : null;
            const sameToken = !!selectedItem && selectedItem.id === ((_c = state.selectedItem) === null || _c === void 0 ? void 0 : _c.id);
            return Object.assign(Object.assign({}, state), { selectedItem, transportGroups: sameToken ? state.transportGroups : [], transportGroupsTokenId: sameToken ? state.transportGroupsTokenId : null });
        }
        case 'TOKEN_SET_SEARCH_VALUE': {
            const { value } = (_d = action.payload) !== null && _d !== void 0 ? _d : {};
            return Object.assign(Object.assign({}, state), { searchValue: value !== null && value !== void 0 ? value : '' });
        }
        case 'TOKEN_ADD_ITEM': {
            const { data } = (_e = action.payload) !== null && _e !== void 0 ? _e : {};
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { items: [...state.items, data] });
        }
        case 'TOKEN_UPDATE_ITEM': {
            const { data } = (_f = action.payload) !== null && _f !== void 0 ? _f : {};
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { selectedItem: ((_g = state.selectedItem) === null || _g === void 0 ? void 0 : _g.id) === data.id ? mergeTokenItem(state.selectedItem, data) : state.selectedItem, items: state.items.map((item) => (item.id === data.id ? mergeTokenItem(item, data) : item)) });
        }
        case 'TOKEN_SET_TRANSPORT_GROUPS': {
            const { groups, tokenId } = (_h = action.payload) !== null && _h !== void 0 ? _h : {};
            if (tokenId == null || ((_j = state.selectedItem) === null || _j === void 0 ? void 0 : _j.id) !== tokenId) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { transportGroups: groups !== null && groups !== void 0 ? groups : [], transportGroupsTokenId: tokenId });
        }
        case 'TOKEN_TOGGLE_TRANSPORT_GROUP': {
            const { id } = (_k = action.payload) !== null && _k !== void 0 ? _k : {};
            if (id == null) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { transportGroups: state.transportGroups.map((item) => (item.id === id ? Object.assign(Object.assign({}, item), { checked: !item.checked }) : item)) });
        }
        default:
            return state;
    }
};
export function tokenLoad() {
    return function tokenLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/token');
            return dispatch(actions.setItems(data));
        });
    };
}
export function tokenCreate(params) {
    return function tokenCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/token', params);
            return dispatch(actions.addItem(data));
        });
    };
}
export function tokenUpdate(id, updateData) {
    return function tokenUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/token/${id}`, updateData);
            return dispatch(actions.updateItem(data));
        });
    };
}
const normalizeTransportGroups = (groups) => (Array.isArray(groups) ? groups : []).map((item) => ({
    id: item.id,
    name: item.name,
    checked: !!item.checked,
}));
export function tokenTransportGroupLoad(id) {
    return function tokenTransportGroupLoadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { data } = yield http.get(`/token/${id}/group`);
            if (((_a = getState().token.selectedItem) === null || _a === void 0 ? void 0 : _a.id) !== id) {
                return;
            }
            return dispatch(actions.setTransportGroups(normalizeTransportGroups(data), id));
        });
    };
}
const isSelectedToken = (getState, id) => { var _a; return ((_a = getState().token.selectedItem) === null || _a === void 0 ? void 0 : _a.id) === id; };
export function tokenTransportGroupPush(id, groupId) {
    return function tokenTransportGroupPushThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post(`/token/${id}/group/${groupId}`);
            if (!isSelectedToken(getState, id)) {
                return;
            }
            return dispatch(actions.toggleTransportGroup(groupId));
        });
    };
}
export function tokenTransportGroupDelete(id, groupId) {
    return function tokenTransportGroupDeleteThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/token/${id}/group/${groupId}`);
            if (!isSelectedToken(getState, id)) {
                return;
            }
            return dispatch(actions.toggleTransportGroup(groupId));
        });
    };
}
export function tokenTransportGroupListPush(id, list) {
    return function tokenTransportGroupListPushThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post(`/token/${id}/groups`, { list });
            if (!isSelectedToken(getState, id)) {
                return;
            }
            list.forEach((groupId) => dispatch(actions.toggleTransportGroup(groupId)));
        });
    };
}
export function tokenTransportGroupListDelete(id, list) {
    return function tokenTransportGroupListDeleteThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/token/${id}/groups`);
            if (!isSelectedToken(getState, id)) {
                return;
            }
            list.forEach((groupId) => dispatch(actions.toggleTransportGroup(groupId)));
        });
    };
}
export default tokenReducer;
